import React from "react";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import AppointmentWithContactInfoSection from "../Section/AppointmentWithContactInfoSection";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";

export default function Pendaftaran() {
  pageTitle("Buat Janji Temu");
  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/home_1/hero_bg.png"
        imgUrl="/images/appointments/banner.jpg"
        title="Pendaftaran Poliklinik"
        subTitle="Silahkan mengisi formulir yang disediakan"
      />
      <Section
        topMd={200}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <AppointmentWithContactInfoSection />
      </Section>
    </>
  );
}
